import { registerAdminReportsBridge } from "./admin-reports.bridge";

export function registerAllReactBridges(moduleName = "ccqapp") {
    registerAdminReportsBridge(moduleName);
}
